// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"725de6c4","796":"62c7a48c"}[chunkId] + ".chunk.js";
};